/**
 * @group Server
 * 
 * @summary
 * <blockquote>Browser stub for Request-scoped ResourceConfig management</blockquote>
 * 
 * @remarks
 * This is a browser-specific implementation that avoids importing Node.js
 * modules like `async_hooks`. It provides a no-op API compatible with the
 * server version so that browser bundles do not include Node-only code.
 * 
 * Browser should manage ResourceConfig via ClientResourceProvider (see
 * `shared/config/src/components/ClientResourceProvider.tsx`).
 */

import type { ResourceConfig } from '../interfaces/ResourceConfig';
import type { RequestContextManagerInterface } from './RequestContextManagerInterface';

class RequestContextManagerBrowserStub implements RequestContextManagerInterface {
  initialize(): void {
    // no-op on browser
  }

  getStack(): ResourceConfig[] {
    // Browser does not use server request context
    return [];
  }

  push(_key: string, _config: ResourceConfig): void {
    // no-op on browser
  }

  pop(_key: string): void {
    // no-op on browser
  }

  clear(): void {
    // no-op on browser
  }

  /** @internal */
  _getStorageInstance(): unknown {
    return undefined;
  }
}

export default new RequestContextManagerBrowserStub();

